<template>
  <div class="back_color">
    <!-- <div class="index_title">
      <span class="back_icon" @click="goBack()"><van-icon name="arrow-left" /></span>
      <span> {{ active == '01' ? '申请换机' : '订单列表' }}</span>
    </div> -->
    <div class="index_body">
      <Request v-if="active == '01'" @request="request"></Request>
      <OrderList v-if="active == '02'"></OrderList>
    </div>
    <div class="bottom flex">
      <div class="flex">
        <div @click="active = '01'">
          <img v-if="active == '01'" src="../../assets/images/unicom/申请已选中@2x.png" style="margin-right: 150px;">
          <img v-else src="../../assets/images/unicom/申请未选中@2x.png" style="margin-right: 150px;">
          <div class="icon_text">
            <span :class="active == '01' ? 'active_text' : ''">申请</span>
          </div>
        </div>
        <div @click="active = '02'">
          <img v-if="active == '02'" src="../../assets/images/unicom/订单已选中@2x.png" alt="">
          <img v-else src="../../assets/images/unicom/订单未选中@2x.png" alt="">
          <div class="icon_text">
            <span :class="active == '02' ? 'active_text' : ''">订单</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Request from './request.vue'
import OrderList from './orderList.vue'
export default {
  name: "index",
  components: { Request, OrderList },
  data() {
    return {
      active: '01',
    }
  },
  mounted(){
    this.$store.commit("clearAdressall");
    // 读取 sessionStorage
    const activeTab = sessionStorage.getItem('activeTab')
    if (activeTab) {
      this.active = activeTab
      sessionStorage.removeItem('activeTab')  // 清除
    }
  },
  methods: {
    request() {
      this.active = '02'
    },
    goBack() {
      this.$router.push({ path: "/Unicom/home" });
    }
  }
}
</script>

<style lang="less" scoped>
// 全局样式重置（可选，避免默认边距影响）
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

// 确保html/body占满窗口高度
html,
body {
  height: 100%;
  overflow: hidden; // 隐藏全局滚动条
}

.flex {
  display: flex;
}

.back_color {
  background-color: #F7F8FA;
  position: fixed; // 父容器固定布局，占满整个窗口
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0; // 移除原padding，避免高度计算偏差

  .index_title {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10; // 确保底部栏在最上层
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    background: #EDEDED;
    font-weight: 500;
    font-size: 32px;
    color: #1D1E20;
    padding: 0 25px;

    .back_icon {
      width: 42%;
    }
  }

  // 核心：填充剩余高度 + 内部滚动
  .index_body {
    position: absolute;
    top: 3px;
    left: 0;
    width: 100%;
    // 计算高度：窗口高度 - 底部栏高度（152px为底部栏总高度）
    height: calc(100% - 130px);
    overflow-y: auto; // 内容超出时内部滚动
    // margin-top: 130px;
  }

  // 固定在底部
  .bottom {
    position: absolute;
    bottom: 0; // 固定到底部
    left: 0;
    background: #FFFFFF;
    box-shadow: 0px -4px 16px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px 20px 0px 0px;
    width: 100%;
    height: 150px; // 固定底部栏高度
    padding-top: 20px;
    justify-content: center;
    z-index: 10; // 确保底部栏在最上层

    img {
      width: 52px;
      height: 49px;
    }

    .icon_text {
      font-size: 25px;
      color: #AFAFAF;
    }

    .active_text {
      color: #577BB5;
    }
  }
}
</style>